export default class TeacherClassManageStudentController {
    // @ngInject
    constructor(targetUser, teacherClass) {
        this.targetUser = targetUser;
        this.teacherClass = teacherClass;
    }
}
